import { createContext } from "react";
import { OpenIdSettings } from "../components/Interfaces/AuthInterfaces";
import { AuthContextProps } from "react-oidc-context";

export interface IAuthContext {
    auth?: AuthContextProps
    openIdSettings: OpenIdSettings,
    setOpenIdSettings: (settings: OpenIdSettings) => void,
}

const AuthContext = createContext<IAuthContext>({} as IAuthContext);

export default AuthContext;
